import $ from '@ali/tarzan-zepto';
import util from '../../../lib/util.js';
import BaseUI from '../../../component/baseui/index.js';
import tpl from './tpl.html';

import './style.scss';

const TAP = util.isPC() ? 'click' : 'tap';

function convert(list) {
  const con = Object.assign({}, list);
  const bundles = con.bundles || [];
  const items = con.items;

  bundles.map((item) => {
    item.button.action = JSON.stringify(item.button.action);
    return item;
  });
  items.map((item) => {
    item.button.action = JSON.stringify(item.button.action);
    return item;
  });

  return con;
}

function sum(list) {
  const con = Object.assign({}, list);
  const bundles = con.bundles || [];
  let len = 0;
  bundles.map((item) => {
    len += item.items.length;
    return item;
  });
  return len;
}


export default function cancelitems(data) {
  const list = convert(data.list);
  list.startPoint = sum(list);
  list.itemword = this.util.lang.get('WORD:ITEM');
  const param = {
    name: 'cancelitems',
    mid: data.mid,
    isFollow: data.isFollow,
    content: tpl.render(list),
  };
  const $node = $(BaseUI.msg(param));
  const order = $node.find('.m-chatpanel-option-button');
  const reasonAction = $node.find('.uncancelable-action');

  reasonAction.on(TAP, (ev) => {
    const $target = $(ev.currentTarget);
    $target.toggleClass('active');
  });

  order.on(TAP, (ev) => {
    const $target = $(ev.currentTarget);
    const value = $target.attr('data-value');
    const action = $target.attr('data-action');
    const flag = $target.attr('data-cancelable');
    if ($target.hasClass('disabled')) return;
    order.addClass('disabled');
    if (flag && flag === 'true') {
      this.postMessage({
        type: 'robot',
        body: {
          text: value,
        },
      }).then((res) => {
        this.view.body.append(res.body);
        this.view.body.scrollToBottom();
      });
    } else {
      this.view.footer.submit({ q: value, ext: { botJson: action } });
    }
  });
  return {
    // 插件返回的结果
    body: $node,
    // 插件调用ready后的回调
    callback: () => {
      //
    },
  };
}



// WEBPACK FOOTER //
// ./src/app/extension/cancelitems/index.js